import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import ActionButton from "../common/button/actionbutton.component.jsx"
import { Redirect } from "@shopify/app-bridge/actions";
import { withRouter } from "react-router";
import GlobalHelper from "../common/GlobalHelper.jsx";
const queryString = require('query-string')
import Integrations from "../integration/Integrations.jsx";
import ShopifyAppContext from '../shopify/shopifyappcontext.js';

const messages = defineMessages({
    "checkout.email_placeholder": {
        id: 'checkout.email_placeholder',
        defaultMessage: 'Email',
    },
    "checkout.first_name_placeholder": {
        id: 'checkout.first_name_placeholder',
        defaultMessage: 'First name',
    },
    "checkout.last_name_placeholder": {
        id: 'checkout.last_name_placeholder',
        defaultMessage: 'Last name',
    },
    "warning": {
        id: 'invoice.pos.warning',
        defaultMessage: 'Warning!',
    },
});

class NewExternalUserModal extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            uri: this.props.uri,
            email: '',
            error: null,
            firstName: '',
            lastName: '',
            isLoading: false,
        }

        this.handleFormChange = this.handleFormChange.bind(this)
        this.createUser = this.createUser.bind(this)
        this.redirectToOrigin = this.redirectToOrigin.bind(this)
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    createUser(event) {
        event.preventDefault()
        this.setState({
            isLoading: true,
        })
        if (this.props.isEmbedded) {
            ShopifyAppContext.getSessionTokenPromise().then(shopifySessionToken => {
                AppContext.getApiClient().get('/auth/' + ShopifyAppContext.integrationKey + '/token?' + queryString.stringify(this.state.uri) + `&sessionToken=${shopifySessionToken}&email=${this.state.email}&firstName=${this.state.firstName}&lastName=${this.state.lastName}`).then(res => {
                    if (!res.error) {
                        AppContext.getApiClient().addApiKeyHeaders(res)
                    }
                    return res
                }).then(response => {
                    if (!response.error) {
                        this.redirectToOrigin()
                    } else {
                        this.setState({ error: response.error, isLoading: false })
                    }
                })
            })
        } else {
            window.location = AppContext.getOptions().apiUrl +
                '/openid/session-authorize/' + ShopifyAppContext.integrationKey + '?' +
                queryString.stringify(this.props.uri) +
                `&sessionToken=${this.props.sessionToken}&email=${this.state.email}&firstName=${this.state.firstName}&lastName=${this.state.lastName}`
        }
    }

    redirectToOrigin() {
        const redirect = Redirect.create(ShopifyAppContext.app);
        redirect.dispatch(Redirect.Action.REMOTE, AppContext.getOptions().webCpqUrl + this.props.redirect + '?' + queryString.stringify(this.props.uri))
    }

    render() {
        return <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <div className="h5 modal-title">
                        <FormattedMessage
                            id="common.sign.new_user.modal.title"
                            defaultMessage="Connect your {integrationName} user to QuoteMachine"
                            values={{
                                integrationName: Integrations.getIntegrationNameFromKey(this.props.integrationKey),
                            }}
                        />
                    </div>
                </div>
                <div className="modal-body overflow-visible">
                    <form>
                        <p>
                            <FormattedMessage
                                id="common.sign.new_user.modal.owner_warning"
                                defaultMessage="Please enter the same email as the one you use in {integrationName}"
                                values={{
                                    integrationName: Integrations.getIntegrationNameFromKey(this.props.integrationKey),
                                }}
                            />
                        </p>

                        <div className="form-group row">
                            <div className="col-12">
                                <label className="mr-3">
                                    <FormattedMessage
                                        id="checkout.email_placeholder"
                                        defaultMessage="Email"
                                    />
                                </label>
                                {
                                    GlobalHelper.validateEmail(this.state.email) ?
                                        <span className="text-small text-success">
                                            <FormattedMessage
                                                id="common.sign.new_user.modal.email_valid"
                                                defaultMessage="Email is valid"
                                            />
                                        </span> :
                                        <span className="text-small text-danger">
                                            <FormattedMessage
                                                id="common.sign.new_user.modal.email_invalid"
                                                defaultMessage="Email is invalid"
                                            />
                                        </span>
                                }
                                <input
                                    type="text"
                                    id="email"
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.handleFormChange}
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["checkout.email_placeholder"])}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-6">
                                <label className="">
                                    <FormattedMessage
                                        id="checkout.first_name_placeholder"
                                        defaultMessage="First name"
                                    />
                                </label>
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    value={this.state.firstName}
                                    onChange={this.handleFormChange}
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["checkout.first_name_placeholder"])}
                                />
                            </div>

                            <div className="col-6">
                                <label className="">
                                    <FormattedMessage
                                        id="checkout.last_name_placeholder"
                                        defaultMessage="Last name"
                                    />
                                </label>
                                <input
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    value={this.state.lastName}
                                    onChange={this.handleFormChange}
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["checkout.last_name_placeholder"])}
                                />
                            </div>
                        </div>
                    </form>
                    {this.state.error && this.state.error.type == "auth_error" &&
                        <div className="alert alert-warning alert-dismissible fade show">
                            <h4 className="alert-heading"><i className="fa fa-warning"></i> {this.props.intl.formatMessage(messages["warning"])}</h4>
                            <div>
                                <p>
                                    "{this.state.error.message}"
                                </p>
                                <FormattedMessage
                                    id="signin.external.please_contact_support"
                                    defaultMessage="Please Contact Support at contact@quotemachine.com"
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className="modal-footer justify-content-end">
                    <ActionButton
                        type="button"
                        onClick={this.createUser}
                        className="btn btn-primary"
                        isLoading={this.state.isLoading}
                        disabled={!GlobalHelper.validateEmail(this.state.email) || !this.state.firstName || !this.state.lastName}
                    >
                        <FormattedMessage
                            id="common.sign.new_user.modal.btn."
                            defaultMessage="Connect"
                        />
                    </ActionButton>

                </div>
            </div>
        </div>
    }

}

export default withRouter(injectIntl(NewExternalUserModal))



// WEBPACK FOOTER //
// ./src/auth/newexternalusermodal.component.jsx